export const LocaIconDefault = (_props: { id: string }): React.ReactNode | null => null